import classNames from 'classnames';

import { isMuxVideo } from '@/components/common/LandingPageHero/utils';
import { MuxVideo } from '@/components/ui/MuxVideo';
import { Image, Video } from '@/components';

import { TypeImage } from '@/core/generated-types';
import { TypeMuxVideoFields } from '@/core/generated-types';
import { TypeMediaAndTextSideBySideFields } from '@/core/generated-types';

export const MediaComponent = ({
  media,
  video,
  videoIsFourThreeAspect,
  image,
  containImage,
}: TypeMediaAndTextSideBySideFields) => {
  if (media && isMuxVideo(media)) {
    const playbackId = (media.fields as TypeMuxVideoFields)?.muxVideoUpload
      ?.playbackId;

    if (!playbackId) return null;

    const props = {
      title: media.fields.entryName || '',
      playbackId,
      autoplay: true,
      controls: !media.fields.hideControls,
    };

    // Wrapper is required to fit the MuxPlayer into the parent container
    return (
      <div
        className={classNames(
          'overflow-hidden',
          videoIsFourThreeAspect ? 'aspect-[4/3]' : 'aspect-[1/1]',
        )}
      >
        <MuxVideo {...props} />
      </div>
    );
  }

  if (video)
    return (
      <Video
        classes={classNames(
          'h-full object-cover w-full',
          videoIsFourThreeAspect ? 'aspect-[4/3]' : 'aspect-[1/1]',
        )}
        src={video.fields.file.url}
        autoplay={true}
        loop={true}
        muted={true}
        playsinline={true}
      />
    );

  if (image)
    return (
      <Image
        imageData={image as TypeImage}
        className={classNames(
          'absolute left-0 top-0 h-full w-full',
          containImage ? 'object-contain' : 'object-cover',
        )}
        alt={image?.fields?.altText}
      />
    );

  return null;
};
